<template>
<div>
    <div v-if="isShowGnb" class="top-navi clear">
        <div class="wrap">
            <h1 class="bold">ITM 수강신청<img src="../assets/img/beta_admin.png" alt="beta" class="ver-top pl-05 pt-05"></h1>
            <ul>
                <li :class="{'on' : onMenu('/admin/reg')}"><a @click="movePage('/admin/reg')">수강신청 등록</a></li>
                <li :class="{'on' : onMenu('/admin/list')}"><a @click="movePage('/admin/list')">수강신청 관리</a></li>
                <li :class="{'on' : onMenu('/admin/guide')}"><a @click="movePage('/admin/guide')">수강신청 제작 가이드</a></li>
                <li :class="{'on' : onMenu('/admin/qna')}"><a @click="movePage('/admin/qna')">1:1 문의</a></li>
                <li :class="{'on' : onMenu('/admin/search')}"><a @click="movePage('/admin/search')">학습자 조회</a></li>
                <li><a @click="logout()">Logout</a></li>
            </ul>
        </div>
    </div>
    <!-- <div class="left-menu">
        <ul>
            <li><a>수강신청 관리</a></li>
            <li :class="{'on' : onMenu('/admin/reg')}"><a @click="movePage('/admin/reg')">수강신청 등록</a></li>
            <li :class="{'on' : onMenu('/admin/list')}"><a @click="movePage('/admin/list')">수강신청 관리</a></li>
            <li :class="{'on' : onMenu('/admin/guide')}"><a @click="movePage('/admin/guide')">제작가이드</a></li>
            <li :class="{'on' : onMenu('/admin/qna')}"><a @click="movePage('/admin/qna')">1:1 문의</a></li>
            <li :class="{'on' : onMenu('/admin/search')}"><a @click="movePage('/admin/search')">학습자 조회</a></li>
            <li><a @click="logout()">Logout</a></li>
        </ul>
    </div> -->
    <router-view />
</div>
</template>

<script>
export default {
    data: () => ({
        isShowGnb: true
    }),

    created() {

    },

    mounted() {
        // console.log('navigator', navigator)
        // console.log('navigator.onLine', navigator.onLine)
        // if (!navigator.onLine) {
        //     alert('인터넷 연결이 원할하지 않습니다.')
        // }
        //         if(navigator.onLine) { // true|false
        //        // ...
        // }
        this.showGnb(this.$route.fullPath)
    },

    watch: {
        // 등록 페이지 내의 현재 라우터 경로 감지
        '$route'(to, from) {
            this.showGnb(to.fullPath)
            this.removeSessionData(to.fullPath, from.fullPath)
            this.redirectMain(to.fullPath, from.fullPath)
        }
    },

    methods: {
        // 불러오기 데이터 삭제 => 뒤로가기로 재호출시 main페이지로 redirect
        redirectMain(toPath, fromPath) {
            if (toPath.includes('/admin/reg') && !toPath.includes('/admin/reg/init')) {
                if (!sessionStorage.getItem('pageIdx')) {
                    alert('수강신청 등록 페이지를 클릭한 경우, 브라우저 \'이전\' 버튼 클릭이 불가능 합니다.')
                    this.$router.push(fromPath)
                }
            }
        },

        // sessionData 지울 시점 지정
        removeSessionData(toPath, fromPath) {
            // if (toPath.includes('/admin/list') && fromPath.includes('/admin/reg')) {
            //     sessionStorage.removeItem('fix')
            //     sessionStorage.removeItem('step')
            //     sessionStorage.removeItem('category')
            //     sessionStorage.removeItem('pOrder')
            //     sessionStorage.removeItem('pageIdx')
            //     sessionStorage.removeItem('mainIdx')
            //     sessionStorage.removeItem('programIdx')
            //     sessionStorage.removeItem('programDupYn')
            // }

            // if (toPath.includes('/admin/reg') && fromPath.includes('/admin/list')) {

            // }
        },

        //  URL에 따라서 GNB 각 우측 버튼 활성화
        showGnb(path) {
            if (path) {
                if (path.includes('/admin/preview')) {
                    this.isShowGnb = false
                } else {
                    this.isShowGnb = true
                }
            }
        },

        // 각 메뉴에 있을 때 메뉴 CSS 활성화
        onMenu(path) {
            if (this.$route.fullPath.includes(path)) {
                return true
            } else {
                return false
            }
        },

        // 각 페이지로 라우팅 (데이터 보존 X)
        movePage(path) {
            if (this.$route.fullPath.includes('reg') && path.includes('reg')) {
                if (sessionStorage.getItem('fix')) {
                    location.href = '/admin/reg/init'
                    // this.$router.push('/admin/reg/init')
                    sessionStorage.removeItem('fix')
                    sessionStorage.removeItem('step')
                    sessionStorage.removeItem('category')
                    sessionStorage.removeItem('pOrder')
                    sessionStorage.removeItem('pageIdx')
                    sessionStorage.removeItem('mainIdx')
                    sessionStorage.removeItem('programIdx')
                    sessionStorage.removeItem('programDupYn')
                } else {
                    return false
                }
            } else {
                this.$router.push(path)
            }

            if (path === '/admin/reg') {
                sessionStorage.removeItem('fix')
                sessionStorage.removeItem('step')
                sessionStorage.removeItem('category')
                sessionStorage.removeItem('pOrder')
                sessionStorage.removeItem('pageIdx')
                sessionStorage.removeItem('mainIdx')
                sessionStorage.removeItem('programIdx')
                sessionStorage.removeItem('programDupYn')
                this.$router.push(path)
            }
        },

        // 로그아웃
        logout() {
            // alert('로그아웃 되었습니다.')
            // localStorage.removeItem('adminId')
            // this.$router.push('/admin/login')

            this.axios.get(this.axios.root + this.axios.port + '/login/out').then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    alert(res.data.result)
                    this.$router.push('/admin/login')
                    localStorage.removeItem('accessToken')
                    localStorage.removeItem('regid')
                    // sessionStorage.setItem('adminId', this.adminId)
                    // this.$router.push('/admin')
                } else if (res.data.err === 401) {
                    this.$router.push('/admin/login')
                    localStorage.removeItem('accessToken')
                    localStorage.removeItem('regid')
                } else {
                    alert(res.data.result)
                }
            }).catch(err => {
                console.log(err)
                alert(err)
                this.$router.push('/admin/login')
                localStorage.removeItem('accessToken')
                localStorage.removeItem('regid')
            })
        }
    }
}
</script>
